var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandToHand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 182,
    viewBox: "0 0 299 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 182,
    fill: "#F9F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.891 64.6256L189.298 54.8201L180.016 31.6592L163 47.0312L177.919 57.1845L177.256 62.3307L178.891 64.6256Z",
    fill: "#798498"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.099 82.5626L200.879 176.107L197.784 180.453H218.668L229.637 100.796L223.406 72.9551",
    fill: "#526181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.522 73.6363L240.713 71.9629V103.261V180.453H217.772L220.197 176.154L211.522 73.6363Z",
    fill: "#E2E2FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.979 24.6683V26.2519C221.116 26.2519 220.416 25.5594 220.416 24.7052C220.416 24.6578 220.418 24.6108 220.422 24.5644C220.51 23.604 221.979 23.704 221.979 24.6683Z",
    fill: "#EDEEEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.617 22.8213V26.6771C213.617 29.6586 215.675 32.2549 218.603 32.9665L224.807 34.4746V19.3991L219.648 18.1451C218.195 17.792 216.659 18.1189 215.482 19.0317C214.305 19.9445 213.617 21.3418 213.617 22.8213V22.8213Z",
    fill: "#E2E2FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.617 26.6772C213.617 29.6587 215.675 32.255 218.603 32.9666L224.807 34.4747",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.631 25.9227C219.963 25.9227 220.231 25.657 220.231 25.3293C220.231 25.0015 219.963 24.7358 219.631 24.7358C219.3 24.7358 219.031 25.0015 219.031 25.3293C219.031 25.657 219.3 25.9227 219.631 25.9227Z",
    fill: "#526181"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.037 25.9226C215.368 25.9226 215.637 25.657 215.637 25.3292C215.637 25.0015 215.368 24.7358 215.037 24.7358C214.705 24.7358 214.437 25.0015 214.437 25.3292C214.437 25.657 214.705 25.9226 215.037 25.9226Z",
    fill: "#526181"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.691 27.3813V22.8213H214.381",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M220.501 22.8211H218.191",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M224.07 26.7415C224.934 26.7415 225.634 26.049 225.634 25.1948",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.437 29.6812C218.631 29.8732 218.894 29.9811 219.169 29.9811C219.443 29.9811 219.707 29.8732 219.901 29.6812",
    stroke: "#798498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.339 24.6245C211.757 21.6442 210.569 15.6859 215.891 13.3701C215.891 13.3701 221.856 9.87564 228.079 14.0482C234.302 18.2207 233.775 32.6179 233.775 32.6179L225.056 31.2078",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.866 19.6292C213.866 19.6292 216.24 19.1858 217.321 18.0645C217.321 18.0645 220.875 23.2775 224.649 22.666",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.848 27.6059L216.857 27.388",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M240.713 49.9827V74.1486L206.098 82.5628V55.6485C206.098 46.1052 212.686 37.7949 222.056 35.5171H222.056C226.55 34.4247 231.302 35.436 234.944 38.2597C238.586 41.0834 240.713 45.406 240.713 49.9827V49.9827Z",
    fill: "#798498"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M217.772 180.453L220.197 176.154L211.522 73.6362",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.42 39.5669C236.42 39.5669 250.872 54.0637 253.544 74.231C256.216 94.3982 234.299 102.048 234.299 102.048L232.432 90.9907L239.22 78.5059L229.637 60.1138",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M234.299 102.048L231.512 85.5356",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M232.037 64.7202L239.221 78.5061L234.528 87.136L232.037 64.7202Z",
    fill: "#526181"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.713 98.8066V105.699L236.103 101.301C237.695 100.575 239.236 99.7412 240.713 98.8066Z",
    fill: "#526181"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M207 48.9668C207 48.9668 203 56.3844 199.5 71.2195L191.5 57.3735C191.5 57.3735 194.383 52.7837 190.726 52.6446C187.07 52.5055 190.164 54.7309 190.164 54.7309C190.164 54.7309 186.929 56.3999 186.789 58.6253",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M205 84.0766C205 84.0766 187 92.4832 183 64.2964",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.875 64.6587C183.875 64.6587 177.632 64.3158 176.902 54.3447",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.388 39.0614L115.182 38C113.959 44.9749 119.285 66 119.285 66L132 55.2857C125.885 44.3684 131.388 39.0614 131.388 39.0614Z",
    fill: "#E2E2FC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.302 73.6782C111.302 73.6782 143.085 137.667 103.269 140.596C63.4529 143.525 52.2649 109.678 52.2649 109.678L47 107.227L63.453 96.3353L85.781 107.227L93.1168 74.4682",
    fill: "#798498"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4318 99.1914C91.6243 99.1914 88.9775 100.695 86.6488 103.351L85.7808 107.227L84.341 106.525C80.2256 113.26 77.5615 124.013 77.5615 136.128C77.5615 136.285 77.5633 136.441 77.5642 136.598C84.3781 139.607 92.8412 141.363 103.269 140.596C106.342 140.37 108.988 139.779 111.255 138.883C111.286 137.973 111.302 137.055 111.302 136.128C111.302 115.728 103.749 99.1914 94.4318 99.1914Z",
    fill: "#526181"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.624 75.0586C105.624 75.0586 109.919 144.404 97.7863 177.236L100.321 180.919H78.7404C78.7404 180.919 76.3828 92.7158 76.3828 73.6782L105.624 75.0586Z",
    fill: "#798498"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7608 21.4057V30.4178L87.4727 33.1616V17.9533L98.7608 15.2095V21.4057Z",
    fill: "#E2E2FC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.682 25.1131C93.0134 25.1131 93.282 24.8474 93.282 24.5197C93.282 24.1919 93.0134 23.9263 92.682 23.9263C92.3507 23.9263 92.082 24.1919 92.082 24.5197C92.082 24.8474 92.3507 25.1131 92.682 25.1131Z",
    fill: "#526181"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3178 25.1131C97.6491 25.1131 97.9178 24.8474 97.9178 24.5197C97.9178 24.1919 97.6491 23.9263 97.3178 23.9263C96.9864 23.9263 96.7178 24.1919 96.7178 24.5197C96.7178 24.8474 96.9864 25.1131 97.3178 25.1131Z",
    fill: "#526181"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6602 26.0054V21.4053H97.9903",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8154 21.4055H94.1456",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2163 23.7626V25.3601C87.345 25.3601 86.6387 24.6615 86.6387 23.7998C86.6387 23.7519 86.6408 23.7046 86.6451 23.6578C86.7335 22.6889 88.2163 22.7897 88.2163 23.7626Z",
    fill: "#EDEEEF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2163 25.3601C87.345 25.3601 86.6387 24.6615 86.6387 23.7998",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5968 29.2936C93.1733 29.2936 92.7671 29.1272 92.4677 28.831C92.1682 28.5349 92 28.1332 92 27.7144",
    stroke: "#798498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7608 30.4175L87.4727 33.1614",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6598 26.0093L94.6406 26.257",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M88.626 22.3187C88.626 22.3187 93.946 19.9334 95.5066 17.8989V19.302C95.5066 19.302 98.3794 18.2497 99.0888 17.022",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7608 19.4776C98.7608 19.4776 101.253 18.4253 100.579 16.1453C99.9048 13.8652 94.6408 12.1114 90.7188 13.1988C90.7188 13.1988 79.1901 15.4262 87.4726 27.3174",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M111.302 49.2994V73.6781L76.3828 82.1664V55.0151C76.3828 45.3878 83.0283 37.0043 92.4813 34.7064H92.4814C97.0147 33.6045 101.809 34.6246 105.482 37.4732C109.156 40.3217 111.302 44.6824 111.302 49.2994V49.2994Z",
    fill: "#E2E2FC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7404 180.919C78.7404 180.919 76.3828 92.7158 76.3828 73.6782",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M105.623 75.0586C105.623 75.0586 109.919 144.404 97.7861 177.236L100.321 180.919",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 38.0522C85.1594 38.0522 69.7937 46.7857 72.4892 65.5872C75.1847 84.3887 111.503 77.3732 120.441 66.9903L121.15 62.5004C121.15 62.5004 126.196 56.3913 123.318 57.692C120.441 58.9927 91.3727 61.0973 91.3727 61.0973L91.8161 54.5028",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M107.038 38.8584C107.038 38.8584 116.146 45.9375 118.719 58.5685",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M112.878 77.3315C112.878 77.3315 126.824 80.6703 132.925 65.0258C138.038 51.9124 134.06 45.6631 132.215 45.2421C130.371 44.8212 129.804 47.3468 129.804 47.3468",
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.6,
    y1: 180.896,
    x2: 281.402,
    y2: 180.896,
    stroke: "#526181",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandToHand);
export default __webpack_public_path__ + "static/media/hand-to-hand.676ed2f108c846c72f720a5825d9c491.svg";
export { ForwardRef as ReactComponent };